import { useState } from 'react'

type ReturnType = {
  values: Set<string>
  expand: (ids: string[], reset?: boolean) => Set<string>
  reset: () => void
  toggle: (id: string) => Set<string>
}

const useUncollpasedNodes = (initial: Set<string>): ReturnType => {
  const [values, setValues] = useState(initial)

  const expand = (ids: string[], reset?: boolean): Set<string> => {
    const previousUncollapsedNodes = reset ? [] : values
    const nextValues = new Set([...previousUncollapsedNodes, ...ids])

    setValues(nextValues)

    return nextValues
  }

  const toggle = (id: string): Set<string> => {
    const nextUncollapsedNodes = values.has(id)
      ? [...values].filter((x) => x !== id)
      : [...values, id]
    const nextValues = new Set(nextUncollapsedNodes)

    setValues(nextValues)

    return nextValues
  }

  const reset = (): void => {
    setValues(new Set([]))
  }

  return { values, expand, toggle, reset }
}

export default useUncollpasedNodes
